import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import { useParams } from 'react-router-dom';

const CancelBooking = () => {
    const { bookingId } = useParams();

    return (
        <>
            <Header />
            <div className="container text-center py-5">
                <h2 className="text-danger">Booking Cancelled</h2>
                <p>Your booking ID <strong>{bookingId}</strong> has been successfully cancelled.</p>
                <p>If this was a mistake, you can rebook your stay anytime.</p>
            </div>
            <Footer />
        </>
    )
}

export default CancelBooking
